import React, { useContext, useEffect, useRef } from "react";
import Dropzone from "dropzone";
import dropzoneTranslations from "../../../util/dropzoneTranslations";
import globalComp from "../../../global/components";
import comp from ".";
import { ProductContext, ModuleContext } from "../provider";
import { AppContext } from "../../../provider/AppProvider";
import { commonStyle } from "../../../util/fabric";

Dropzone.autoDiscover = false;
let imageUrls: any = [];

function FileUpload_Prd() {
  let t = window.INITIAL_DATA.TRANSLATIONS;

  const { setProductPreview } = useContext(AppContext);
  const { printPaper } = useContext(ProductContext);
  const { setModuleInfo, moduleInfo } = useContext(ModuleContext);

  // ref
  const fileUploadDropzoneRef = useRef<Dropzone | null>(null);

  useEffect(() => {
    setModuleInfo({
      ...moduleInfo,
      ...commonStyle,
    });
  }, []);

  useEffect(() => {
    if (!fileUploadDropzoneRef.current && printPaper) {
      fileUploadDropzoneRef.current = new Dropzone(
        document.getElementById("file-upload-dropzone"),
        Object.assign(
          {
            url: `${window.woocommerce_params.ajax_url}?action=upload_pdf`,
            maxFiles: 1,
            parallelUploads: 1,
            uploadMultiple: true,
            timeout: 360000,
            acceptedFiles: ".pdf",
            addRemoveLinks: true,
            dictDefaultMessage: "test",
            removedfile(file: Dropzone.DropzoneFile) {
              file.previewElement.remove();
            },
            completemultiple(files: Dropzone.DropzoneFile[]): void {
              if (files.length && files[0].xhr) {
                try {
                  imageUrls = imageUrls.concat(
                    JSON.parse(files[0].xhr.response)
                  );
                } catch (e) {
                  console.log(
                    e,
                    window.INITIAL_DATA.TRANSLATIONS.dropzone_ResponseError
                  );
                }
              }
            },
          },
          dropzoneTranslations()
        )
      );
    }
  }, [printPaper]);

  return (
    <>
      {printPaper && (
        <>
          <globalComp.FieldHeader
            number={1}
            title={t.verify_characteristics}
            tooltipStr={t.tooltip_verify_characteristics}
            extraCssClass={"product-section-row flex-column align-items-start"}
            element={
              <div className={"d-flex flex-column"}>
                <p className={"mb-4 mt-2"}>
                  {`${t.before_upload_verify_characteristics} :`}
                </p>
                <div className="container-fluid p-0">
                  <div className="row no-gutter">
                    <div className="col-12 col-md-5 mb-3 mb-md-0">
                      <div className={"product-section__file-upload-info"}>
                        <ul>
                          <li>
                            {`${t.size} `}
                            <span>{`${printPaper.width}${printPaper.unit} x ${printPaper.height}${printPaper.unit}`}</span>
                          </li>
                          <li>{`${t.no_abundances}`}</li>
                          <li>
                            {`${t.extension} :`} <span>PDF</span>
                          </li>
                          <li>
                            {`${t.resolution}`}:{" "}
                            <span>{`${printPaper.dpi}dpi`}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-12 col-md-7">
                      <div
                        className={
                          "d-flex flex-column flex-grow-1 product-section__file-upload-note"
                        }>
                        <p>{`${t.change_quantity}`}</p>
                        <p>{`${t.before_printing_instructions}`}</p>
                        <p>
                          {`${t.file_upload_maximum_size} `}
                          <span>250MB</span>.{`${t.in_case_heavier_file}`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          />

          <globalComp.FieldHeader
            number={2}
            title={t.upload_the_file}
            tooltipStr={t.tooltip_upload_the_file}
            extraCssClass={"product-section-row flex-column align-items-start"}
            clearAfter={true}
            element={
              <div className={"product-section__file-upload-dropzone pt-3"}>
                <form className="dropzone" id="file-upload-dropzone" />
              </div>
            }
          />

          <comp.ProductControls
            preview={() => {
              setProductPreview({ jpg: imageUrls[0].jpg });
            }}
          />
        </>
      )}
    </>
  );
}

export default FileUpload_Prd;
